import { ReactNode, useEffect } from "react";
import { useSession } from "@/lib/auth-client";

// simple global to prevent double seeding
let embeddedSessionConsumed = false;

interface AuthProviderProps {
  children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  // initialize session on app mount; if window.__SESSION__ present, rely on better-auth's lazy fetch being skipped after manual prime
  const { data: session, isPending } = useSession();

  useEffect(() => {
    // if library didn't yet return a session and we have embedded one we can short-circuit some dependent ui (future: provide to lib directly if api exposed)
    if (embeddedSessionConsumed) return;
    if (typeof window !== "undefined" && (window as any).__SESSION__) {
      // currently better-auth client fetch still happens; future enhancement: expose setter in auth-client to seed cache
      embeddedSessionConsumed = true;
    }
  }, [session, isPending]);

  return <>{children}</>;
}
